import {
  FILTER_ASSET_TYPES,
  FilterAssetType,
  FilterAssetTypeKey,
} from "domains/file-manager/constants/AssetFilter";
import _ from "lodash";

export default function reduceAssetFilterToTypes(types: FilterAssetTypeKey[]) {
  return _.uniq(
    types.reduce<FilterAssetType["value"]>((memo, type) => {
      return memo.concat(FILTER_ASSET_TYPES[type].value);
    }, [])
  );
}
